// extracted by mini-css-extract-plugin
module.exports = {"bestProductWrapper":"styles_bestProductWrapper__2_PBj","card":"styles_card__F_xpi","disclaimer":"styles_disclaimer__3wnCM","carousel":"styles_carousel__1THlZ"};